/* eslint-disable camelcase */
import JWTDecode from 'jwt-decode'
import Axios from 'axios'
import qs from 'querystring'

import AuthError from '../lib/AuthError'
//import { VUE_APP_API } from '../config'
import store from '../store'
const request = Axios.create({ baseURL: process.env.VUE_APP_API })
function debug(...messages) {
  console.debug('[AUTH]', ...messages)
}

export default class OAuthTokenService {
  constructor() {
    this.axios = Axios.create({
      baseURL: process.env.VUE_APP_API,
      //withCredentials: true,
      timeout: 30000,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization:
          'Basic Mzp6SkJDWE42Tm5kb1cxdldGbXJiMVJPY05SMUNNUGJXblI2N3NrM1Jz'
      }
    })

    this.timeOffset = 0
  }

  async getTimeOffset() {
    const timestampServer =
      (await this.axios.get('user/timeAtual').then(r => r.data.timeAtual)) *
      1000
    const timestampClient = Date.now()

    this.timeOffset = timestampClient - timestampServer
    return this.timeOffset
  }

  get accessToken() {
    return localStorage.getItem('soae_access_token')
  }

  set accessToken(v) {
    if (v == null) {
      localStorage.removeItem('soae_access_token')
    } else localStorage.setItem('soae_access_token', v)
  }

  get refreshToken() {
    return localStorage.getItem('soae_refresh_token')
  }

  set refreshToken(v) {
    if (v == null) {
      localStorage.removeItem('soae_refresh_token')
    } else localStorage.setItem('soae_refresh_token', v)
  }

  get payload() {
    try {
      return JWTDecode(this.accessToken)
    } catch (e) {
      return null
    }
  }

  auth(data) {
    return this.axios({
      method: 'POST',
      url: '/oauth/token',
      //withCredentials: false,
      data: qs.stringify(data)
    }).then(res => res.data)
  }

  get isAuthenticated() {
    const payload = this.payload
    return !!payload
  }

  tokenIsExpired() {
    const { payload } = this

    if (!payload || !payload.exp) return false
    return (Date.now() - this.timeOffset) / 1000 >= payload.exp - 1
  }

  refreshAccessToken() {
    debug('Obtendo um novo token de acesso...')

    return this.auth({
      grant_type: 'refresh_token',
      refresh_token: this.refreshToken,
      escola: localStorage.getItem('escola')
    })
      .then(res => this.setToken(res))
      .catch(async error => {
        console.dir(error)
        if (error.response.status === 401) {
          await this.logout(true)
          return null
        }
      })
  }

  setToken({ access_token, refresh_token }) {
    this.accessToken = access_token
    this.refreshToken = refresh_token
    return access_token
  }

  async checkAccessToken() {
    debug('Verificando validade do token de acesso...')

    if (this.tokenIsExpired()) {
      debug('O token expirou!')
      await this.refreshAccessToken()
    }

    debug('O token está válido.')

    return this.accessToken
  }

  recoverAccount(email, novaSenha) {
    return request({
      method: 'POST',
      url: '/password/reset',
      data: {
        email,
        novaSenha
      }
    })
  }

  login(username, password, domain) {
    //console.log('Fazendo login...')

    return this.auth({
      grant_type: 'password',
      scope: 'professor',
      username,
      password,
      escola: domain
    })
      .then(res => {
        this.setToken(res)
        localStorage.setItem('pessoa_id', res.pessoa_id)
      })
      .catch(err => {
        if (err.name === 'AuthError') {
          throw err
        }

        if (!err.response) {
          throw new AuthError('Falha na conexão!')
        }

        if (err.response) {
          if (err.response.data.error === 'invalid_grant') {
            throw new AuthError('Nome de usuário e/ou senha inválidos!')
          }

          throw new AuthError('Erro interno do servidor')
        }
      })
  }

  async logout(refresh = true) {
    if (!this.accessToken) return null

    debug('Encerrando sessão...')

    await request({
      method: 'DELETE',
      url: '/logout',
      noAuth: true
    }).catch(() => false)

    if (refresh) {
      window.location.reload(true)
    } else if (this.accessToken) {
      store.dispatch('toast', {
        message: 'A sessão expirou, faça login novamente.'
      })
    }

    this.accessToken = null
    this.refreshToken = null
  }
}

export const Auth = new OAuthTokenService()
